/**
 * L4 — Two Visual Split
 * Left 50%: primary image/video
 * Right 50%: secondary image/video
 * Headline overlaid at bottom spanning full width
 */
import React from 'react';
import { AbsoluteFill } from 'remotion';
import type { SceneProps } from '../../types';
import {
  SceneContainer, Visual, HeadlineText,
  GlobalOverlays, AccentBar,
} from './shared';

export const L4_TwoVisualSplit: React.FC<SceneProps> = (props) => {
  const { headline, assets, colorPalette, headlineFont } = props;
  const primary = assets.primary;
  const secondary = assets.secondary ?? assets.images?.[1] ?? assets.primary;

  return (
    <SceneContainer bg={colorPalette.background}>
      {/* Two side-by-side visuals */}
      <AbsoluteFill style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ width: '50%', height: '100%', overflow: 'hidden', position: 'relative' }}>
          <Visual asset={primary} kenBurns kenBurnsDirection="in" layerKey="primaryMedia" />
          {/* Center divider edge fade */}
          <div style={{
            position: 'absolute', top: 0, right: 0, width: 3, height: '100%',
            background: colorPalette.accent,
          }} />
        </div>
        <div style={{ width: '50%', height: '100%', overflow: 'hidden' }}>
          <Visual asset={secondary} kenBurns kenBurnsDirection="out" layerKey="secondaryMedia" />
        </div>
      </AbsoluteFill>

      {/* Bottom headline bar */}
      <AbsoluteFill style={{
        background: 'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.5) 40%, transparent 80%)',
      }} />

      <AbsoluteFill style={{
        display: 'flex', flexDirection: 'column',
        justifyContent: 'flex-end',
        padding: '0 80px 100px',
      }}>
        <AccentBar color={colorPalette.accent} style={{ marginBottom: 12 }} />
        <HeadlineText
          text={headline}
          font={{ ...headlineFont, color: '#fff', fontSize: Math.min(headlineFont.fontSize, 48) }}
          delay={8}
          maxLines={2}
          layerKey="headline"
        />
      </AbsoluteFill>

      <GlobalOverlays props={props} />
    </SceneContainer>
  );
};
